"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModel = void 0;
function ViewModel(props) {
    const { column, searchValue, sortBy, asc, onSort, onSearch } = props;
    return {
        column,
        searchValue,
        sortBy,
        asc,
        onClick() {
            if (column.sortable && typeof onSort === "function") {
                onSort();
            }
        },
        onSearch() {
            if (column.searchable && typeof onSearch === "function") {
                onSearch();
            }
        },
    };
}
exports.ViewModel = ViewModel;
